<template>
	<div class="loginView"  :style="{background: bgc}">
		<div class="zhezhao">
			<!-- 会员登录 -->
			<div class="userLogin">
				<!-- 左侧 -->
				<div class="loginLeft">
					<img :src="bgc2" style="width: 100%;height: 100%;">
				</div>
				<!-- 右侧 -->
				<div class="loginRight" v-loading="loading">
					<div class="rightTop">
						<span style="font-size: 20px;font-weight: bold;">{{title}}</span>
						<span style="font-size: 14px;margin-top: 10px;">欢迎您!</span>
					</div>
					<div class="rightBot">
						<el-input v-model="userName" placeholder="请输入账号" prefix-icon="el-icon-user"></el-input>
						<el-input v-model="passWord" placeholder="请输入密码" type="password" prefix-icon="el-icon-lock"
							style="margin-top: 20px;"></el-input>
						<div
							style="display: flex;height: 50px;align-items: center;justify-content: space-between;font-size: 12px;">
							<div>
							</div>
							<!-- <el-checkbox v-model="checked" size="small" :border="true"
								style="border: none;padding-left: 0;">记住密码</el-checkbox> -->
<!--							 <p style="margin-right: 5px;color: #015AAA;cursor: pointer;"
								@click="$router.push('/register')">企业注册</p>-->
							<p style="margin-right: 5px;color: #015AAA;cursor: pointer;"
								@click="$router.push('/forget')">忘记密码</p
              ><p style="margin-right: 5px;color: #015AAA;cursor: pointer;"
								@click="$router.push('/register')">注册</p>
						</div>
						<el-button type="primary" class="specialBtn" @click="submitLogin">登录</el-button>
<!--						<div class="login_inner">
							<a href="https://www.kancloud.cn/leftcat/process/2955037" target="_blank">
								<p>申报流程</p>
							</a>
							<a href="https://www.kancloud.cn/leftcat/question/2955038" target="_blank">
								<p>常见问题</p>
							</a>
							<a href="https://www.kancloud.cn/leftcat/support/2955039" target="_blank">
								<p>技术支持</p>
							</a>
						</div>-->
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import {
		userLogin
	} from "@/api/moudles/user.js"
	export default {
		data() {
			return {
				userName: '',
				passWord: '',
				loading: false,
				checked: false,
        title:'项目申报',
        bgc: '',
        bgc2: '',
			}
		},
    created() {
      this.title = localStorage.getItem("companyName")

      let bkimg = localStorage.getItem("loginBkPath")
      let logoImg = localStorage.getItem("logoImg")
      this.bgc =  `url(${bkimg}) 100% 100% no-repeat`
      this.bgc2 =  logoImg
    },
    methods: {
			async submitLogin() {
				const params = {
					username: this.userName.trim(),
					password: this.passWord.trim()
				}
				if (!params.username || !params.password) {
					this.$notify.error({
						title: '错误',
						message: '账号或密码未输入'
					});
					return
				}
				this.loading = true
				await userLogin({
					data: params,
					success: (res) => {
						console.log(res)
						this.loading = false
						if (res.code != 200) {
							this.$notify.error({
								title: '登录失败',
								message: res.msg
							});
							return
						}
						this.$message({
							message: '登录成功',
							type: 'success'
						});
						setTimeout(() => {
							localStorage.setItem('token', res.data.token)
							localStorage.setItem('userName', res.data.name)
							localStorage.setItem('userLevel', res.data.level)
							localStorage.setItem('userCompany', res.data.enp_name)
							this.$router.push('/index')
						}, 1000)
					},
					fail: (err) => {
						this.loading = false
						this.$notify.error({
							title: '登录失败',
							message: err
						});
					}
				})
			}
		}
	}
</script>

<style scoped>
	.zhezhao {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 2;
		/*background: rgba(0, 0, 0, 0.8);*/
	}

	.loginView {
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		z-index: 1;
	/*	background: url(../../assets/img/login/bg.png) 100% 100% no-repeat;*/
	}


	/* 用户登录 */
	.userLogin {
		margin-left: auto;
		margin-top: 15%;
		/* margin-top: 270px; */
		margin-right: auto;
		width: 700px;
		height: 410px;
		display: flex;
		border-radius: 10px;
		/* box-shadow: 0px 0px 12px 3px #EEEEEE; */
		background-color: #ffffff;
	}

	.userLogin .loginLeft {
		width: 48%;
		border-radius: 10px 0 0 10px;
		overflow: hidden;
	}

	.userLogin .loginRight {
		width: 52%;
		border-radius: 0 10px;
		padding: 30px 40px;
		box-sizing: border-box;
	}

	.rightTop {
		height: 25%;
		width: 100%;
		color: #015AAA;
		display: flex;
		flex-flow: column;
	}

	.rightBot {
		height: 75%;
		width: 100%;
	}

	.specialBtn {
		margin-top: 50px;
		width: 100%;
		height: 40px;
		background: #015AAA;
		border-radius: 8px;
	}
	.login_inner{
		display: flex;
		justify-content: space-around;
		height: 55px;
		align-items: center;
	}
	.login_inner p{
		display: inline-block;
		color: #015AAA;
		font-size: 14px;
		font-weight: 500;
		cursor: pointer;
	}
</style>
